import self from './caas/self'

export default {
    ...self
  }
